import React from "react";
import { Phone, Mail, MessageSquare } from "lucide-react";

// Call / Email / Message buttons for every profile. Renders disabled pills when data is missing.
export default function ContactButtons({ phone, email, onMessage, testId = "contact" }) {
  const base = "flex flex-col items-center justify-center gap-1 p-2.5 rounded-2xl text-[10px] font-extrabold transition-colors";
  const disabled = `${base} bg-[#FFF9F2] text-[#D1D5DB] cursor-not-allowed`;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testId}-buttons`}>
      {phone ? (
        <a href={`tel:${phone}`} className={`${base} bg-[#E2F4E1] text-[#2F6031] hover:bg-[#D2EBD1]`} data-testid={`${testId}-call`}>
          <Phone className="w-4 h-4" /> Call
        </a>
      ) : (
        <span className={disabled} data-testid={`${testId}-call`}>
          <Phone className="w-4 h-4" /> Call
        </span>
      )}
      {email ? (
        <a href={`mailto:${email}`} className={`${base} bg-[#E6F2FA] text-[#3D7E9E] hover:bg-[#D6EBF7]`} data-testid={`${testId}-email`}>
          <Mail className="w-4 h-4" /> Email
        </a>
      ) : (
        <span className={disabled} data-testid={`${testId}-email`}>
          <Mail className="w-4 h-4" /> Email
        </span>
      )}
      {onMessage ? (
        <button onClick={onMessage} className={`${base} bg-[#FCE6E9] text-[#B2607F] hover:bg-[#F8C8DC]`} data-testid={`${testId}-message`}>
          <MessageSquare className="w-4 h-4" /> Message
        </button>
      ) : phone ? (
        <a href={`sms:${phone}`} className={`${base} bg-[#FCE6E9] text-[#B2607F] hover:bg-[#F8C8DC]`} data-testid={`${testId}-message`}>
          <MessageSquare className="w-4 h-4" /> Message
        </a>
      ) : (
        <span className={disabled} data-testid={`${testId}-message`}>
          <MessageSquare className="w-4 h-4" /> Message
        </span>
      )}
    </div>
  );
}
